import React, { memo, useState, useEffect } from 'react'; //, { useState, useEffect, useRef, memo  }
import styles from './loadsCard.module.scss';
import plannerViewStyles from '../plannerView.module.scss';
import { sendRequest, API_ROOT } from '../../../supplementary_components/requests';
import { addNotification } from '../../../supplementary_components/store';
import { LoadObject, WARNINGS_ARRAY, extractStopLatLng } from './loadObject';
import { loadStatusFormatter, loadStatusColorGenerator } from '../../../pages/loads/loadDataDelegate';
import { checkIfLoadHasTrailer, suggestToUploadBOLIfNotAttached, ConfirmUnhooking } from '../../../general_components/content_management/task_list/taskListElements/singleAction';
import { priceOnFinish } from '../../../supplementary_components/priceInputDelegate';
import { TaskCard, openPopup, positionPopup } from './taskCard';
import { useBoardStore } from '../../boardStore';
import { FaTriangleExclamation } from "react-icons/fa6";



function statusChangeButtonGenerator(currentLoad){
	if(!currentLoad)return null;
	if(currentLoad.loadStatus === "NotDispatched")return {label: "Mark As Dispatched"};
	const stopsArray = currentLoad.stops;
	if(currentLoad.loadStatus === "Dispatched" && !stopsArray[0].status)return {label: "Mark As Arrived"};
	// if(currentLoad.loadStatus === "Dispatched")return "Mark As Onsite";
	
	for(let i = 0; i < stopsArray.length; i++ ){
		if(i === 0 && stopsArray[i].status === "inProgress")return {requirement: "TrailerNumber", loadStartDate: stopsArray[i].apptDate, loadEndDate: stopsArray[stopsArray.length-1].apptDate,  label: "Mark As Picked Up"};
		if(i === stopsArray.length-1){
			if(!stopsArray[i].status)return {label: "Arrived To Consignee"};
			if(stopsArray[i].status === "inProgress" || stopsArray[i].status === "completed")return {lastStop: true, dropAndHookStop: stopsArray[i].loadingType === "hook&drop", label: "Mark As Completed"} ;
		}else{
			if(!stopsArray[i].status)return {label: `Arrived To Stop #${i+1}`};
			if(stopsArray[i].status === "inProgress")return {label: `Heading To Stop #${i+2}`};
		}
	}
}
function openUpcomingLoad(loadId){
	const setPopupRaw = useBoardStore.getState().setPopupRaw;
	const openPopupLoad = useBoardStore.getState().openPopupLoad;
	const upsertLoad = useBoardStore.getState().upsertLoad;
	setPopupRaw({loadNumber:true, loading:true});
	sendRequest('GET', `${API_ROOT}loads/${loadId}`, null, (resp)=>{
		try { upsertLoad(resp); } catch (e) {}
		openPopupLoad(resp?.id || loadId);
	}, ()=>{addNotification({message:`Something went wrong`, type:'alert'})}, null);
}

const SingleLoadCard = memo(({object, overflowContainer, popupViewManagingObject, open, setOpen, truckId}) => {
	const openPopupLoad = useBoardStore(s => s.openPopupLoad);
	const HVLoad = object.loadType === "FTLHighValue";
	return <div
		id={`Load${object.loadNumber}`}
		data-load-id={object.loadId}
		className={`${styles.card} ${object.loadType === "Partial" ? styles.partialLoad : ''} ${styles[`load${object.status}`]} ${object.startPercentage ? styles['hasNoStart'] : ''} ${object.endPercentage ? styles['hasNoEnd'] : ''}`}
		style={{position:"absolute", left:object.startOffset+"px", width: object.width+"px", maxWidth: object.width+"px"}} 
		onClick={(e)=>{
			e.stopPropagation();
			if(object.actualCurrentLoad || (object.upcomingLoad && (object.status === "NotDispatched" || Object.keys(object.warnings).length > 0 ))){
				if(overflowContainer && overflowContainer.current){
					if(!open){
						openPopup(e, overflowContainer.current, true)
						popupViewManagingObject(object.loadId, overflowContainer, setOpen);							
						const handleClick = () => {
							setOpen(false);
							if(object.upcomingLoad){
								openUpcomingLoad(object.loadId);
							}else{
								openPopupLoad(object.loadId);
							}
						};
						const loadNumberTag = overflowContainer.current.querySelector("#loadNumber");
						const newLoadNumberTag = loadNumberTag.cloneNode(true);
						loadNumberTag.parentNode.replaceChild(newLoadNumberTag, loadNumberTag);
						newLoadNumberTag.innerText = object.loadNumber;
						const warningCount = Object.keys(object.warnings).length;						
						if(warningCount > 0){
							overflowContainer.current.querySelector("#warningBlockBottom").style.display = '';
							if(warningCount > 0){
								overflowContainer.current.querySelector("#warningBlock").style.display = '';
								let content = ``;
								for(const key of Object.keys(object.warnings)){
									const warningVal = object.warnings[key];
									content += `${warningVal && warningVal===true ? WARNINGS_ARRAY[parseInt(key)] : warningVal}!<br />`
								}
								overflowContainer.current.querySelector("#warningBlockContent").innerHTML = content;
							}else{
								overflowContainer.current.querySelector("#warningBlock").style.display = 'none';
							}
							// if(object.etaToNextStop){
							// 	overflowContainer.current.querySelector("#warningBlock").className = '';
							// 	overflowContainer.current.querySelector("#warningBlockBottom").style.display = '';
							// 	// overflowContainer.current.querySelector("#etaBlockContent").innerHTML = object.etaToNextStop;
							// }else{
							// 	overflowContainer.current.querySelector("#warningBlock").className =  plannerViewStyles.hasBottomLine;
							// }
						}else{
							overflowContainer.current.querySelector("#warningBlock").style.display = 'none';
							// overflowContainer.current.querySelector("#etaBlock").style.display = 'none';
							overflowContainer.current.querySelector("#warningBlockBottom").style.display = 'none';
						}

						newLoadNumberTag.addEventListener("click", handleClick);
						const statusTag = overflowContainer.current.querySelector("#currentStatus");
						statusTag.innerText = loadStatusFormatter(object.status);
						statusTag.style.backgroundColor = loadStatusColorGenerator(object.status);
						populateWuthStopsAndETAs(object, overflowContainer.current, truckId, () => setOpen(false));
						// overflowContainer.current.querySelector("#firstPUDateTime").innerText = object.loadStartDateTime;
						// overflowContainer.current.querySelector("#firstPUCityState").innerText = `${object.puCity}, ${object.puState}`;
						// overflowContainer.current.querySelector("#lastDELDateTime").innerText = object.loadEndDateTime;
						// overflowContainer.current.querySelector("#lastDELCityState").innerText = `${object.destCity}, ${object.destState}`;
						const loadRateTag = overflowContainer.current.querySelector("#loadRate");
						if(loadRateTag){
							loadRateTag.innerText = priceOnFinish(`${object.amountForInvoice}`, true);
						}
						const statusChangeButton = overflowContainer.current.querySelector("#statusChangeButton");
						const newStatusChangeButton = statusChangeButton.cloneNode(true);
						newStatusChangeButton.style.display = "";
						statusChangeButton.parentNode.replaceChild(newStatusChangeButton, statusChangeButton);
						if(object.upcomingLoad && object.status !== "NotDispatched"){
							overflowContainer.current.querySelector("#statusChangeButton");
							newStatusChangeButton.style.display = "none";
							positionPopup(e, overflowContainer.current);
							setOpen(!open);
							return
						}
						
						const changeStatusButtonObject = statusChangeButtonGenerator(object.actualCurrentLoad);
						
						newStatusChangeButton.querySelector("span").innerText = changeStatusButtonObject === null ? "Mark As Dispatched" : changeStatusButtonObject.label;
						const showHideLoadingIcon = (show)=>{
							try {
								newStatusChangeButton.querySelector("svg").style.opacity = show ? "1.0" :  "0.0";
							} catch (error) {}
						}
						const moveLoadToNextStage = (unhookTrailer) => {
							sendRequest("POST", API_ROOT+"loads/moveToNextStage?loadId="+object.loadId + (unhookTrailer ? "&removeTrailer=True":""), null, ()=>{
								showHideLoadingIcon(false);
								newStatusChangeButton.removeEventListener("click", handleStatusChange);
								setOpen(false);					
							}, ()=>{
								showHideLoadingIcon(false);
								addNotification({message:`Something went wrong`, type:'alert'});
							})
						}
						const handleStatusChange = () => {
							showHideLoadingIcon(true);
							if(changeStatusButtonObject === null || object.status === "NotDispatched" ){
								moveLoadToNextStage();
							}else{
								if(changeStatusButtonObject.requirement === "TrailerNumber"){
									checkIfLoadHasTrailer(object.loadId, changeStatusButtonObject.loadStartDate, changeStatusButtonObject.loadEndDate, ()=>{
										moveLoadToNextStage()
									}, showHideLoadingIcon);
								}else if(changeStatusButtonObject.lastStop){
										
									suggestToUploadBOLIfNotAttached(object.loadId, ()=>{
										if(changeStatusButtonObject.dropAndHookStop){
											ConfirmUnhooking(moveLoadToNextStage)
										}else{
											moveLoadToNextStage();
										}
									}, ()=>{
										showHideLoadingIcon(false);
										setOpen(false);
									})
								}
								else{
									moveLoadToNextStage();
								}
							}
						};
						newStatusChangeButton.addEventListener("click", handleStatusChange);
						// Position after the popup content is populated (one pass)
						positionPopup(e, overflowContainer.current);
						setOpen(!open);
					}
				}
			}else{
				openUpcomingLoad(object.loadId);
			}
		}}	
		>
		<div >
			{object.pickupWindowWidth ? <div style={{width: object.pickupWindowWidth+"px"}}  className={styles.pickupWindowIndicator}></div> : null}
			{!object.startPercentage ? 
			<>
			<div className={`${styles.childDiv} ${styles.secondToShrink}`}>
				{object.puCity},
			</div>
			<div className={`${styles.childDiv} ${styles.lastToShrink}`}>
				{object.puState}
			</div>
			</>:null}
			{HVLoad ? <div className={`${styles.hvMarker} ${styles.childDiv} ${styles.lastToShrink} ${object.status === "Completed" || object.status === "ReadyForInvoice" ? styles.Completed : ""}`}>
			    <FaTriangleExclamation />
			</div> : null}
			
			<div className={`${styles.childDiv} ${styles.firstToShrink}`} style={{textAlign: HVLoad ? "left" : "center"}}>
				{object.mileage}m
			</div>
			{!object.endPercentage ? <>
			<div className={styles.padder}>
			</div>
			<div  className={`${styles.childDiv} ${HVLoad ? "" : styles.cityToRight} ${styles.secondToShrink}`}>{object.destCity},</div>
			<div  className={`${styles.childDiv} ${HVLoad ? "" : styles.stateToRight} ${styles.lastToShrink}`}>{object.destState}</div>
			</>:null}
			{ object.status && !object.status.includes("Late") && (Object.keys(object.warnings).length > 0 || object.etaData?.late )? <span className={styles.warningIndicator}></span> : null}
		</div>
	</div>
}, (prevProps, nextProps) => {
	// Custom comparison: only re-render if load data actually changed
	return (
		prevProps.object.loadId === nextProps.object.loadId &&
		prevProps.object.status === nextProps.object.status &&
		prevProps.object.startOffset === nextProps.object.startOffset &&
		prevProps.object.width === nextProps.object.width &&
		prevProps.object.loadNumber === nextProps.object.loadNumber &&
		prevProps.open === nextProps.open &&
		prevProps.object.etaData === nextProps.object.etaData
	);
}); 
export const CompletedLoad = memo(({loadData})=>{
	return <SingleLoadCard object={loadData} />
})
export const TaskBlock = memo(({taskData, popupViewManagingObject, overflowContainer, truckId})=>{
	const [open, setOpen] = useState(false);
	useEffect(() => {
		_setOpen(false);
	// eslint-disable-next-line
	}, [taskData])
	const _setOpen = (val) => {
		if(!val){
			if(overflowContainer && overflowContainer.current){
				overflowContainer.current.style.display = "";
			}
		}else{
			if(overflowContainer && overflowContainer.current){
				overflowContainer.current.style.display = "block";
			}
		}
		setOpen(val);
	}
	return <TaskCard  data={taskData} overflowContainer={overflowContainer} popupViewManagingObject={popupViewManagingObject} open={open} setOpen={_setOpen} truckId={truckId} />
})

export const ActiveLoad = memo(({loadData, timelineStartInMills, currentTimeRef, popupViewManagingObject, overflowContainer, truckId}) => {
	
	const [open, setOpen] = useState(false);
	const _setOpen = (val) => {
		if(!val){
			if(overflowContainer && overflowContainer.current){
				overflowContainer.current.style.display = "";
			}
		}else{
			if(overflowContainer && overflowContainer.current){
				overflowContainer.current.style.display = "block";
			}
		}
		setOpen(val);
	}
	
	// Always subscribe to plannerTick (hooks must be called unconditionally)
	// But only use it in the useMemo if this load actually needs time-based updates
	const plannerTick = useBoardStore(s => s.plannerTick);
	
	// Only subscribe to this specific load, not the entire loadsById map
	const liveLoad = useBoardStore(s => s.loadsById?.[loadData.loadId]);
	
	// Check if load needs time-based updates
	const needsTimeUpdates = React.useMemo(() => {
		return loadData.hasToCheckInBefore != null || loadData.reliesOnCurrentTimeLine === true;
	}, [loadData.hasToCheckInBefore, loadData.reliesOnCurrentTimeLine]);
	
	const computedLoadObject = React.useMemo(() => {
		
		
		const base = liveLoad ? { ...liveLoad } : (loadData.actualCurrentLoad ? { ...loadData.actualCurrentLoad } : null);
		if(!base || !base.id){
			return loadData;
		}
		// preserve shared-load cropping percentages from the initially computed LoadObject
		if(loadData.startPercentage !== undefined) base.startPercentage = loadData.startPercentage;
		if(loadData.endPercentage !== undefined) base.endPercentage = loadData.endPercentage;
		const updated = new LoadObject(base, timelineStartInMills, loadData.previousLoadsActionTime, currentTimeRef, true, !!loadData.upcomingLoad, truckId);
		updated.nextLoadId = loadData.nextLoadId;
		return updated;
	// Only include plannerTick in deps if this load needs time updates
	// eslint-disable-next-line
	}, [needsTimeUpdates ? plannerTick : null, liveLoad, loadData.loadId, timelineStartInMills, needsTimeUpdates]);
	useEffect(() => {
		// close popup on structural load changes (prevents stale popup content)
		_setOpen(false);
	// eslint-disable-next-line
	}, [computedLoadObject.loadId, computedLoadObject.width, computedLoadObject.startOffset]);
	return <SingleLoadCard object={computedLoadObject} popupViewManagingObject={popupViewManagingObject} overflowContainer={overflowContainer} open={open} setOpen={_setOpen} truckId={truckId} />
})

function setCopyableCityState(el, latLng){
	if(!el) return;
	if(latLng){
		el.dataset.latlng = latLng;
		el.classList.add(plannerViewStyles.copyableCoords);
		el.title = 'Copy coordinates';
	}else{
		delete el.dataset.latlng;
		el.classList.remove(plannerViewStyles.copyableCoords);
		el.removeAttribute('title');
	}
}
function populateWuthStopsAndETAs(loadData, container, truckId, closePopup){
	const stops = loadData.actualCurrentLoad?.stops;
	const firstStopLatLng = loadData.puLatLng || extractStopLatLng(stops?.[0]);
	const lastStopLatLng = loadData.destLatLng || extractStopLatLng(stops?.[stops.length - 1]);
	container.querySelector("#firstPUDateTime").innerText = loadData.loadStartDateTime;
	const firstPUCityState = container.querySelector("#firstPUCityState");
	firstPUCityState.innerText = `${loadData.puCity}, ${loadData.puState}`;
	setCopyableCityState(firstPUCityState, firstStopLatLng);
	container.querySelector("#lastDELDateTime").innerText = loadData.loadEndDateTime;
	const lastDELCityState = container.querySelector("#lastDELCityState");
	lastDELCityState.innerText = `${loadData.destCity}, ${loadData.destState}`;
	setCopyableCityState(lastDELCityState, lastStopLatLng);
	const inbetweenCityState = container.querySelector("#inbetweenStopPUCityState");
	setCopyableCityState(inbetweenCityState, null);
	try {
		if(!loadData.etaData){
			container.querySelector("#firstStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#lastStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopTimeHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopPUCityState").parentElement.style.display = "none";
		}else if(loadData.etaData.etaToFirstStop){
			etaHolderAdjuster(container.querySelector("#firstStopETAHolder"), loadData.etaData, truckId, loadData.loadId, closePopup);
			container.querySelector("#lastStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopTimeHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopPUCityState").parentElement.style.display = "none";
		}else if(loadData.etaData.etaToLastStop){
			etaHolderAdjuster(container.querySelector("#lastStopETAHolder"), loadData.etaData, truckId, loadData.loadId, closePopup);
			container.querySelector("#firstStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopTimeHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#inbetweenStopPUCityState").parentElement.style.display = "none";
		}else if(loadData.etaData.stopNumber){
			container.querySelector("#firstStopETAHolder").parentElement.style.display = "none";
			container.querySelector("#lastStopETAHolder").parentElement.style.display = "none";
			// container.querySelector("#inbetweenStopETAHolder").parentElement.style.display = "block";
			const cityStateHolder = container.querySelector("#inbetweenStopPUCityState");
			const timeHolder = container.querySelector("#inbetweenStopTimeHolder");
			cityStateHolder.parentElement.style.display = "";
			timeHolder.parentElement.style.display = "";
			etaHolderAdjuster(container.querySelector("#inbetweenStopETAHolder"), loadData.etaData, truckId, loadData.loadId, closePopup);
			container.querySelector("#inbetweenStopNumberHolder").innerText = `Stop #${loadData.etaData.stopNumber}:`;
			timeHolder.innerText = loadData.etaData.stopTimeLbl;
			cityStateHolder.innerText = loadData.etaData.stopCityState;
			const inbetweenLatLng = loadData.etaData.stopLatLng
				|| extractStopLatLng(stops?.[loadData.etaData.stopNumber - 1]);
			setCopyableCityState(cityStateHolder, inbetweenLatLng);
		}
	} catch (error) {
		console.log(error);
	}
	


 }
function applyEtaPresentation(etaHolder, etaData){
	const label = etaHolder.querySelector(".etaLabel");
	etaHolder.parentElement.style.display = "";
	const text = etaData.eta.includes("away") ? etaData.eta : `ETA: ${etaData.eta}`;
	if(label) label.textContent = text;
	else etaHolder.innerText = text;
	if(etaData.late && !etaHolder.classList.contains(plannerViewStyles.late)){
		etaHolder.classList.add(plannerViewStyles.late);
	}else if(!etaData.late){
		etaHolder.classList.remove(plannerViewStyles.late);
	}
}
function etaHolderAdjuster(etaHolder, etaData, truckId, loadId, closePopup){
	try {
		applyEtaPresentation(etaHolder, etaData);
		etaHolder.classList.remove(plannerViewStyles.refreshing);
		if(!truckId || !loadId){
			etaHolder.onclick = null;
			delete etaHolder.dataset.etaLoadId;
			return;
		}
		etaHolder.dataset.etaLoadId = String(loadId);
		delete etaHolder.dataset.etaRequest;
		etaHolder.onclick = (event) => {
			event.stopPropagation();
			event.preventDefault();
			if(etaHolder.classList.contains(plannerViewStyles.refreshing)) return;
			const requestToken = `${Date.now()}`;
			etaHolder.dataset.etaRequest = requestToken;
			etaHolder.classList.add(plannerViewStyles.refreshing);
			const stillCurrent = () => etaHolder.dataset.etaRequest === requestToken && etaHolder.dataset.etaLoadId === String(loadId);
			const stopLoading = () => {
				if(!stillCurrent()) return false;
				delete etaHolder.dataset.etaRequest;
				etaHolder.classList.remove(plannerViewStyles.refreshing);
				return true;
			};
			const timer = setTimeout(() => {
				if(etaHolder.dataset.etaRequest === requestToken){
					delete etaHolder.dataset.etaRequest;
					etaHolder.classList.remove(plannerViewStyles.refreshing);
					addNotification({message:`Couldn't update ETA`, type:'alert'});
				}
			}, 75000);
			sendRequest("POST", `${API_ROOT}trucks/${truckId}/refresh-eta?loadId=${loadId}`, null, (resp) => {
				clearTimeout(timer);
				if(!stopLoading()) return;
				if(!resp || resp.updated !== true){
					addNotification({message:`Couldn't update ETA`, type:'alert'});
					return;
				}
				if(resp.geofence === true){
					if(closePopup) closePopup();
					return;
				}
				if(!resp.eta){
					addNotification({message:`Couldn't update ETA`, type:'alert'});
					return;
				}
				applyEtaPresentation(etaHolder, { eta: resp.eta, late: resp.late === true });
				try {
					const { loadsById, upsertLoad } = useBoardStore.getState();
					const existing = loadsById?.[resp.loadId];
					const trucksETA = {
						eta: resp.eta,
						late: resp.late === true,
						stopNumber: resp.stopNumber
					};
					upsertLoad(existing ? { ...existing, trucksETA } : { id: resp.loadId, trucksETA });
				} catch (e) {}
			}, () => {
				clearTimeout(timer);
				if(!stopLoading()) return;
				addNotification({message:`Couldn't update ETA`, type:'alert'});
			});
		};
	} catch (error) {
		console.log(error);
	}
}